import { Button, Input } from "@material-tailwind/react"
import useResizeObserver from "@react-hook/resize-observer"
import { useMutation, useQueryClient } from "@tanstack/react-query"
import Spinner from "components/utils/Spinner"
import { AlertContext } from "contexts/AlertProvider"
import ContentHeightContext from "contexts/ContentHeightContext"
import useAxiosPrivate from "hooks/useAxiosPrivate"
import useObject from "hooks/useObject"
import { useContext, useEffect, useState } from "react"
import { useMediaQuery } from "react-responsive"
import { ReactSetterType, User } from "utils/types"
import userImg from 'assets/images/user.svg';
import resolveImgUrl from "utils/resolveImgUrl"
import GalleryPicker from "components/GalleryPicker"


type UserData = 
Partial<
    Omit<
        User
    , 'id' | 'isAdmin' > 
>
& {id ?: number} 
& {password ?: string | null}

type Prop = {
    setMenuOpened : ReactSetterType<boolean>
    selected : number | null,
}

const UserCreateMenu = ({
    selected,
    setMenuOpened
} : Prop)=>{

    const [data, setData, setObject, intentData] = useObject<UserData>({
        id : undefined,
        name : '',
        email : '',
        password : '',
        phone : '',
        profilePicture : undefined,
    })
    const axiosPrivate = useAxiosPrivate();
    const queryClient = useQueryClient();
    const {setAlert} = useContext(AlertContext);
    const {height : contentHeight} = useContext(ContentHeightContext);

    useEffect(()=>{
        selected && axiosPrivate.get(`/user/${selected}`)
            .then(({data : _data})=>{
                console.log(_data)
                const {isAdmin, ...data} = _data as User
                setData({...data});
            }).catch((err)=>{
                setAlert('error', 'Cannot fetch user, contact admin for further information')
            })
    }, [selected])

    function postHandler(data : UserData){
        if(!data.id)
            return axiosPrivate.post('user', data);
        else
            return axiosPrivate.put(`user/${data.id}`, data);
    }

    const {mutate : postBusiness, isLoading} = useMutation(postHandler, {
      onSuccess(){
        queryClient.invalidateQueries(['user']); 

        if(!data.id)
            setAlert('success', 'User Posted !')
        else
            setAlert('success', 'User Updated !')

        setMenuOpened(false);
      },
      onError(err : any){
        setAlert('error', err.message + ' contact admin for further detail' as string);
      }
    })

    function submitHandler(){
        async function submit(){
            let _data = data
            if(!_data.email)
                throw new Error('Email cant be empty')
            if(!_data.name)
                throw new Error('Name cant be empty')
            if(!_data.id && !_data.password)
                throw new Error('Password cant be empty')
            if(!_data.password)
                delete _data.password
            if(!_data.phone)
                delete _data.phone
            postBusiness({
                ..._data,
            })
        }

        submit().catch((err:Error)=>setAlert('error', err.message))
    } 

    if(selected && !(data.id))
        return(
            <div className="absolute left-0 top-0 w-full" style={{height : contentHeight}}>
                <div className="sticky z-10 top-0 left-0 w-full h-screen">
                    <div className="relative w-full h-full">
                        <div className="absolute top-0 left-0 w-full h-full bg-black opacity-30 z-[11]" onClick={()=>setMenuOpened(false)}></div>
                        <div className="absolute top-0 left-0 w-full h-full z-[12] grid place-content-center">
                            <Spinner></Spinner>
                        </div>
                    </div>
                </div>
            </div>
        )
    else
    return (
    <div className="absolute left-0 top-0 w-full" style={{height : contentHeight}}>
        <div className="sticky z-10 top-0 left-0 w-full h-screen">
            <div className="relative w-full h-full">
                <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-[90%] z-[12] gap-y-3 flex flex-col bg-white shadow-md max-w-3xl p-5">
                    <div className="flex justify-center items-center">
                      <GalleryPicker postImageUrl='/user/image' onSelect={(e)=>intentData((prev)=>{prev.profilePicture = e; return prev})}>
                          {(reference, referenceProp)=>
                              <div ref={reference} {...referenceProp} className="rounded-full w-16 h-16 group relative overflow-hidden cursor-pointer">
                                <div className="absolute top-0 left-0 bg-black w-full h-full opacity-0 group-hover:opacity-40 grid place-content-center">
                                  <i className="fas fa-pen text-white"></i>
                                </div>
                                <img src={data.profilePicture ? resolveImgUrl(data.profilePicture): userImg} className="w-full h-full rounded-full object-cover" alt="" />
                              </div>
                          }
                      </GalleryPicker>
                    </div>
                    <Input label="Name" value={data.name} onChange={(e)=>{setData({name : e.target.value})}}/>
                    <Input label="Email" value={data.email} onChange={(e)=>{setData({email : e.target.value})}}/>
                    <Input label="Phone" value={data.phone || ''} onChange={(e)=>{setData({phone : e.target.value})}}/>
                    <Input label="Password" value={data.password || ''} onChange={(e)=>{setData({password : e.target.value})}}/>
                    <Button onClick={submitHandler}>Submit</Button>
                </div>
                <div className="absolute top-0 left-0 w-full h-full bg-black opacity-30 z-[11]" onClick={()=>setMenuOpened(false)}></div>
            </div>
        </div>
    </div>)
}

export default UserCreateMenu